<template>
    <b-container>
        <h5 class="mt-4 p-2 text-center text-primary text-uppercase">Configuraciones</h5>
        <div class="text-center">
            <div class="logo-profile shadow my-4">
                <figure>
                    <img :src="logo ? logo : '/img/logo_login.png'" alt="logo partner" title="Logo Partner">
                </figure>
                <b-button variant="default" class="text-white floating-btn">
                    <i class="material-icons">camera_alt</i>
                    <b-form-file
                        name="logo"
                        v-model="form.logo"
                        v-validate="(!logo ? 'required:true|' : '') + 'image'"
                        :data-vv-as="(labels.logo).toLowerCase()"
                        aria-describedby="logo-live-feedback"
                        :state="(form.logo ? Boolean(form.logo) : form.logo) || validateState('logo')"
                        accept="image/*"
                        class="float-file"
                        :disabled="loading || user.branch"/>
                </b-button>
                <b-form-invalid-feedback
                    id="logo-live-feedback"
                    :state="validateState('logo')"
                >{{ veeErrors.first('logo') }}</b-form-invalid-feedback>
            </div>
        </div>
        <b-form id="formPartner" @submit.stop.prevent="update()">
            <b-row align-h="center">
                <b-col cols="12" md="5" align-self="start">
                    <b-form-group :label="labels.code+':'">
                        <b-form-input
                            name="code"
                            v-model="form.code"
                            type="text"
                            class="text-center"
                            v-validate="'required:true'"
                            :state="validateState('code')"
                            :data-vv-as="(labels.code).toLowerCase()"
                            disabled
                            aria-describedby="code-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="code-live-feedback">{{
                                veeErrors.first('code')
                            }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="5" align-self="start">
                    <b-form-group :label="labels.branch_code+':'">
                        <b-form-input
                            name="branch_code"
                            v-model="form.branch_code"
                            type="text"
                            class="text-center"
                            v-validate="'required:true'"
                            :state="validateState('branch_code')"
                            :data-vv-as="(labels.branch_code).toLowerCase()"
                            disabled
                            aria-describedby="branch_code-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="branch_code-live-feedback">{{
                                veeErrors.first('branch_code')
                            }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="5" align-self="start">
                    <b-form-group :label="labels.name+':'">
                        <b-form-input
                            name="name"
                            v-model="form.name"
                            type="text"
                            class="text-center"
                            v-validate="'required:true'"
                            :state="validateState('name')"
                            :data-vv-as="(labels.name).toLowerCase()"
                            :disabled="loading || user.branch"
                            aria-describedby="name-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="name-live-feedback">{{
                                veeErrors.first('name')
                            }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="5" align-self="start">
                    <b-form-group :label="labels.phone+':'">
                        <b-form-input
                            name="phone"
                            v-model="form.phone"
                            type="tel"
                            inputmode="tel"
                            class="text-center"
                            v-validate="'required:true'"
                            :state="validateState('phone')"
                            :data-vv-as="(labels.phone).toLowerCase()"
                            :disabled="loading || user.branch"
                            aria-describedby="phone-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="phone-live-feedback">{{
                                veeErrors.first('phone')
                            }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="10" align-self="start">
                    <hr>
                </b-col>
                <b-col cols="12" md="10" align-self="start">
                    <b-form-group :label="labels.address+':'">
                        <b-form-input
                            name="address"
                            v-model="form.address"
                            type="text"
                            class="text-center"
                            v-validate="'required:true'"
                            :state="validateState('address')"
                            :data-vv-as="(labels.address).toLowerCase()"
                            :disabled="loading || user.branch"
                            aria-describedby="address-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="address-live-feedback">{{
                                veeErrors.first('address')
                            }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="5" align-self="start">
                    <b-form-group :label="labels.city+':'">
                        <b-form-input
                            name="city"
                            v-model="form.city"
                            type="text"
                            class="text-center"
                            v-validate="'required:true'"
                            :state="validateState('city')"
                            :data-vv-as="(labels.city).toLowerCase()"
                            :disabled="loading || user.branch"
                            aria-describedby="city-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="city-live-feedback">{{
                                veeErrors.first('city')
                            }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="5" align-self="start">
                    <b-form-group :label="labels.state+':'">
                        <b-form-input
                            name="state"
                            v-model="form.state"
                            type="text"
                            class="text-center"
                            v-validate="'required:true'"
                            :state="validateState('state')"
                            :data-vv-as="(labels.state).toLowerCase()"
                            :disabled="loading || user.branch"
                            aria-describedby="state-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="state-live-feedback">{{
                                veeErrors.first('state')
                            }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="10" align-self="start">
                    <b-form-group :label="labels.maps+':'">
                        <b-form-input
                            name="maps"
                            v-model="form.maps"
                            type="text"
                            class="text-center"
                            v-validate="'required:true'"
                            :state="validateState('maps')"
                            :data-vv-as="(labels.maps).toLowerCase()"
                            :disabled="loading || user.branch"
                            aria-describedby="maps-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="maps-live-feedback">{{
                                veeErrors.first('maps')
                            }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="10" align-self="start">
                    <hr>
                </b-col>
                <b-col cols="12" md="5" align-self="start">
                    <b-form-group :label="labels.currency_1+':'">
                        <b-form-select
                            name="currency_1"
                            :options="yes_no"
                            :value="form.currency_1"
                            v-model="form.currency_1"
                            class="form-control select-center"
                            v-validate="'required:true'"
                            :state="validateState('currency_1')"
                            :data-vv-as="(labels.currency_1).toLowerCase()"
                            :disabled="loading || user.branch"
                            aria-describedby="currency_1-live-feedback"
                        ></b-form-select>
                        <b-form-invalid-feedback id="currency_1-live-feedback">{{
                                veeErrors.first('currency_1')
                            }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="5" align-self="start">
                    <b-form-group :label="labels.currency_2+':'">
                        <b-form-select
                            name="currency_2"
                            :options="yes_no"
                            :value="form.currency_2"
                            v-model="form.currency_2"
                            class="form-control select-center"
                            v-validate="'required:true'"
                            :state="validateState('currency_2')"
                            :data-vv-as="(labels.currency_2).toLowerCase()"
                            :disabled="loading || user.branch"
                            aria-describedby="currency_2-live-feedback"
                        ></b-form-select>
                        <b-form-invalid-feedback id="currency_2-live-feedback">{{
                                veeErrors.first('currency_2')
                            }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="10" align-self="start">
                    <b-form-group :label="labels.open+':'">
                        <b-form-input
                            name="open"
                            v-model="form.open"
                            type="text"
                            class="text-center"
                            v-validate="'required:true'"
                            :state="validateState('open')"
                            :data-vv-as="(labels.open).toLowerCase()"
                            :disabled="loading || user.branch"
                            aria-describedby="open-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="open-live-feedback">{{
                                veeErrors.first('open')
                            }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row align-h="center">
                <b-col cols="12" md="10" align-self="center" class="text-center my-4">
                    <b-button type="submit" variant="default" size="lg" pill class="shadow px-5"
                              form="formPartner" :disabled="loading">
                        <b-spinner small type="grow" v-if="loading"></b-spinner>
                        <b-icon icon="upload" aria-hidden="true" v-else></b-icon>
                        &nbsp;&nbsp;<span>{{ loading ? 'Actualizando...' : 'Actualizar' }}</span>
                    </b-button>
                </b-col>
            </b-row>
        </b-form>
    </b-container>
</template>

<script>
import axios from "axios";

export default {
    name: "PartnerSettings",
    props: ['user'],
    data: () => ({
        labels: {
            code: 'Código',
            branch_code: 'Sucursal',
            logo: 'Logo',
            name: 'Nombre',
            phone: 'Teléfono',

            address: 'Dirección',
            city: 'Ciudad',
            state: 'Estado',
            maps: 'Ubicación GPS',

            currency_1: 'Moneda Local',
            currency_2: 'Dolares',
            open: 'Horario'
        },
        form: {
            code: null,
            branch_code: null,
            logo: null,
            name: null,
            phone: null,

            address: null,
            city: null,
            state: null,
            maps: null,

            currency_1: null,
            currency_2: null,
            open: null
        },
        yes_no: [
            {text: 'Si', value: '1'},
            {text: 'No', value: '0'}
        ],
        loading: false,
        logo: undefined
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'settingspage');
        this.getIni();
    },
    watch: {
        'user.partner'() {
            this.getIni();
        },
        'form.logo'() {
            if (this.form.logo) {
                this.getImg();
            }
        },
    },
    methods: {
        getIni() {
            this.loading = true;
            axios.get('/api/partner/settings').then((res) => {
                if (res.data.status === 'success') {
                    this.form.code = res.data.info.code;
                    this.form.branch_code = res.data.info.branch_code;
                    if (res.data.info.logo) {
                        this.logo = '/' + res.data.info.logo;
                    } else {
                        this.logo = null;
                    }
                    this.form.logo = null;
                    this.form.name = res.data.info.name;
                    this.form.phone = res.data.info.phone;
                    this.form.address = res.data.info.address;
                    this.form.city = res.data.info.city;
                    this.form.state = res.data.info.state;
                    this.form.maps = res.data.info.maps;
                    this.form.currency_1 = res.data.info.currency_1;
                    this.form.currency_2 = res.data.info.currency_2;
                    this.form.open = res.data.info.open;
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.loading = false;
            });
        },
        getImg() {
            let input = this.form.logo;

            if (input) {
                const reader = new FileReader;
                reader.onload = e => {
                    this.logo = e.target.result;
                };
                reader.readAsDataURL(input);
            }

        },
        update() {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    this.$root.$bvToast.toast('Por favor, revise el formulario e intente nuevamente', {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    return;
                }
                this.loading = true;
                let formData = new FormData();

                formData.append('logo', this.form.logo);
                formData.append('name', this.form.name);
                formData.append('alias', this.form.alias);
                formData.append('phone', this.form.phone);
                formData.append('address', this.form.address);
                formData.append('city', this.form.city);
                formData.append('state', this.form.state);
                formData.append('maps', this.form.maps);
                formData.append('currency_1', this.form.currency_1);
                formData.append('currency_2', this.form.currency_2);
                formData.append('open', this.form.open);

                axios.post('/api/partner/settings/update', formData, {
                    headers: {'Content-Type': 'multipart/form-data'}
                }).then((res) => {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    if (res.data.status === 'success') {
                        this.getIni();
                        this.$validator.reset();
                    }
                }).catch(err => {
                    this.$root.$bvToast.toast(err.response.data.errors, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }).then(() => {
                    this.loading = false;
                });
            });
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetValidationState() {
            this.isValid = undefined
        }
    }
}
</script>

<style scoped>

</style>
